const configTerms = {
    privacy: {
        termsKey: 'cs_privacy',
    },
    stipulation: {
        termsKey: 'cs_stipulation',
    },
    payment:{
        termsKey:  'cs_credit_msg'
    },
    quit:{
        termsKey:  'cs_leave'
    },
    withdrawal:{
        termsKey: 'cs_withdraw'
    },
    refund:{
        termsKey:  'cs_refund'
    },
    cafe:{
        termsKey:  'cs_cafe_open'
    },
    cafeclose:{
        termsKey:  'cs_cafe_close'
    },
}

export default {
    methods: {
        returnTermsConfig(type) {
            return configTerms[type];
        }
    },
    data(){
        return{
            languageList : [
                {c_code:"KR", c_idx:1, c_is_use:1, c_lang:"한국어", c_lang_en:"Korean", c_lang_ko:"한국어", c_location:"KO", c_name_kr:"대한민국", c_name_us:"Korea, Republic Of", c_number:"82"},
                {c_code:"US", c_idx:30, c_is_use:1, c_lang:"English", c_lang_en:"English", c_lang_ko:"영어", c_location:"EN", c_name_kr:"미국", c_name_us:"United States", c_number:"1"},
                {c_code:"CN", c_idx:3, c_is_use:1, c_lang:"中國語", c_lang_en:"Chinese", c_lang_ko:"중국어", c_location:"ZH", c_name_kr:"중화인민공화국", c_name_us:"China", c_number:null},
            ]
        }
    }
}